import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../services/modal.service';

import { I18nTranslator } from '../../../i18n/translate';
import { ZSNCampaign, ZSNOrder } from '../../../models/zsn.model';
import { CampaignYearPipe } from '../../../pipes/campaignYear.pipe';
import { HectareConverterPipe } from '../../../pipes/hectareConverter.pipe';
import { ListFarmsForOrderPipe, ListUsersForOrderPipe } from '../../../pipes/orders.pipe';
import { FarmService } from '../../../services/farm.service';
import { OrganisationService } from '../../../services/organisation.service';
import { ZSNService } from '../../../services/zsn.service';
import { OrderComponent } from '../agrorendement/common/orders.component';
import { ZSNUtils } from './zsn.utils';
import { TranslatePipe, TranslateDatePipe, TranslateWithPunctuationPipe } from '../../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-zsn-orders-cmp',
  templateUrl: '../agrorendement/common/orders.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    CommonModule,
    FormsModule,
    DatePipe,
    CampaignYearPipe,
    HectareConverterPipe,
    ListUsersForOrderPipe,
    ListFarmsForOrderPipe,
    TranslatePipe,
    TranslateDatePipe,
    TranslateWithPunctuationPipe,
    PaginationModule,
  ],
  providers: [ZSNService, FarmService, OrganisationService],
})
export class ZSNOrderComponent extends OrderComponent<ZSNCampaign, ZSNOrder> implements OnInit, AfterViewInit {
  @ViewChild('termCampaignFilter') termCampaignFilter: ElementRef;
  @ViewChild('termFarmFilter') termFarmFilter: ElementRef;
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  @ViewChild('allFilters', { static: true }) allFilters: ElementRef;

  constructor(
    protected service: ZSNService,
    protected farmService: FarmService,
    protected organisationService: OrganisationService,
    protected i18nTranslator: I18nTranslator,
    protected router: Router,
    protected modal: ModalService,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.zsn.section');
    this.specyUrlPart = ['zsn'];
    this.specyOrderCode = 'ORDZ';
  }

  isOrderEditable(order: ZSNOrder): boolean {
    return ZSNUtils.isOrderEditable(order);
  }
}
